export const notificationTypeLabels = {
    MISSED_CALL: 'Chamada Perdida',
    APPT_REMINDER: 'Agendamento',
    TASK: 'Tarefa',
    ALERT: 'Alerta'
};

export const notificationPriorityLabels = {
    LOW: 'Baixa',
    MEDIUM: 'Média',
    HIGH: 'Alta'
};

const alertDisplayMap = {
    STAGE_2_HYPERTENSION: {
        category: 'Pressão Arterial',
        description: 'Pressão arterial elevada registada'
    },
    SEVERE_HYPERTENSION: {
        category: 'Pressão Arterial',
        description: 'Pressão arterial muito elevada registada'
    },
    HIGH_GLUCOSE: {
        category: 'Glicemia',
        description: 'Glicose elevada registada'
    },
    LOW_GLUCOSE: {
        category: 'Glicemia',
        description: 'Glicose baixa registada'
    },
    LOW_OXYGEN: {
        category: 'Oxigénio no Sangue',
        description: 'Oxigénio no sangue baixo registado'
    },
    HIGH_HR_AGE: {
        category: 'Frequência Cardíaca',
        description: 'Frequência Cardíaca elevada registada'
    }
};

export const formatNotificationDate = (isoDate, withTime = true) => {
    if (!isoDate) {
        return '';
    }

    const date = new Date(isoDate);

    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return date.toLocaleString('pt-PT', {
        day: '2-digit',
        month: '2-digit',
        ...(withTime
            ? {
                  hour: '2-digit',
                  minute: '2-digit'
              }
            : {})
    });
};

const formatNotificationDayAndTime = (isoDate) => {
    if (!isoDate) {
        return '';
    }

    const date = new Date(isoDate);

    if (Number.isNaN(date.getTime())) {
        return '';
    }

    const day = date.toLocaleDateString('pt-PT', {
        day: '2-digit',
        month: '2-digit'
    });

    const time = date.toLocaleTimeString('pt-PT', {
        hour: '2-digit',
        minute: '2-digit'
    });

    return `dia ${day} às ${time}`;
};

export const getNotificationCategory = (notification) => {
    const notificationType = (notification?.type || '').toUpperCase();
    const alertCode = String(notification?.data?.alert || '').toUpperCase();

    if (notificationType === 'ALERT' && alertDisplayMap[alertCode]?.category) {
        return alertDisplayMap[alertCode].category;
    }

    return notificationTypeLabels[notificationType] || notification?.type || 'Notificação';
};

export const getNotificationDescription = (notification) => {
    const notificationType = (notification?.type || '').toUpperCase();
    const notificationData = notification?.data || {};
    const action = String(notificationData?.action || '').toUpperCase();
    const scheduleText = formatNotificationDate(notification?.not_before);
    const displayContext = notification?._displayContext || {};
    const subjectName = displayContext?.subjectName || '';
    const contextualDayAndTime = formatNotificationDayAndTime(
        displayContext?.referenceTs || notification?.not_before
    );

    if (notificationType === 'MISSED_CALL') {
        if (notificationData?.name) {
            return `${notificationData.name} não conseguiu entrar em contacto.`;
        }

        return 'Recebeste uma chamada não atendida.';
    }

    if (notificationType === 'APPT_REMINDER') {
        if (subjectName && contextualDayAndTime) {
            return `Com ${subjectName}, ${contextualDayAndTime}.`;
        }

        if (action === 'CREATED') {
            return 'Foi criado um novo agendamento.';
        }

        if (action === 'CANCELLED') {
            return 'Um agendamento foi cancelado.';
        }

        if (action === 'REMINDER') {
            return scheduleText
                ? `Lembrete de agendamento ativo desde ${scheduleText}.`
                : 'Tens um lembrete de agendamento pendente.';
        }

        return 'Existe uma atualização relacionada com um agendamento.';
    }

    if (notificationType === 'ALERT') {
        const alertCode = String(notificationData?.alert || '').toUpperCase();
        const alertDisplay = alertDisplayMap[alertCode];

        if (subjectName && contextualDayAndTime) {
            return `${subjectName}, ${contextualDayAndTime}.`;
        }

        if (alertDisplay?.description && scheduleText) {
            return `${alertDisplay.description} a ${scheduleText}.`;
        }

        if (alertDisplay?.description) {
            return `${alertDisplay.description}.`;
        }
    }

    if (scheduleText) {
        return `Notificação ativa desde ${scheduleText}.`;
    }

    return 'Tens uma nova notificação pendente.';
};
